var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScalpel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3698 16.1743C12.3699 16.1743 12.3698 16.1744 12.3698 16.1743L12.3733 16.1714L14.0983 14.4348L10.6415 10.9549L8.91315 12.6949L12.3698 16.1743Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2411 17.6484L7.61646 13.9995L2 19.6535C3.95317 21.6198 7.67178 21.8088 11.2411 17.6484Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6464 13.3834L20.8055 8.98885C22.3122 7.70542 22.4075 5.39971 21.0119 3.99475C19.6162 2.58979 17.3259 2.68569 16.051 4.20248L11.6855 9.39596L15.6464 13.3834Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalpel);
export default __webpack_public_path__ + "static/media/scalpel.06ace9a1402bcc39448cded333c7cdbc.svg";
export { ForwardRef as ReactComponent };